import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from "axios";

const initialState = {
    merchants: [],
    allPaymentMethods: [],
    loading: 'IDLE',
    error: null
}

export const getMerchants = createAsyncThunk(
    'merchant/get',
    async (data) => {
        let response = await axios.get(`${process.env.REACT_APP_API_URL}/api-admin/get-merchants`)
        return response.data
    }
)

export const editMerchants = createAsyncThunk(
    'merchant/edit',
    async (data) => {
        let response = await axios.post(`${process.env.REACT_APP_API_URL}/api-admin/edit-merchant`, data)
        return response.data
    }
)

export const getAllPaymentMethods = createAsyncThunk(
    'merchant/getAllPaymentMethods',
    async () => {
        let response = await axios.get(`${process.env.REACT_APP_API_URL}/api-admin/get-all-payment-methods`)
        return response.data
    }
)

export const updateMerchantPaymentMethods = createAsyncThunk(
    'merchant/updateMerchantPaymentMethods',
    async (data) => {
        let response = await axios.post(`${process.env.REACT_APP_API_URL}/api-admin/update-merchant-payment-methods`, data)
        return response.data
    }
)

export const merchantSlice = createSlice({
    name: 'merchant',
    initialState,
    reducers: {
        editArray: (state, action) => {

            let newMerchant = {...action.payload}

            const merchant = state.merchants.find((merchant) => merchant.id === newMerchant.id)
            if (merchant) {
                for (const merchantKey in newMerchant) {
                    if (merchantKey === 'paymentMethods' || merchantKey === 'merchantPaymentMethods') continue
                    merchant[merchantKey] = Number(newMerchant[merchantKey])
                }
            }
        },
        updateMerchantOrder: (state, action) => {
            state.merchants = action.payload;
        },
        updateMerchantPaymentMethodsLocal: (state, action) => {
            const { merchantId, paymentMethods } = action.payload
            const merchant = state.merchants.find((m) => m.id === merchantId)
            if (merchant) {
                merchant.paymentMethods = paymentMethods
            }
        },
    },
    extraReducers: (builder) => {
        builder

            .addCase(getMerchants.pending, (state) => {
                state.loading = 'loading';
                state.error = null;
            })

            .addCase(editMerchants.pending, (state) => {
                state.loading = 'loading';
                state.error = null;
            })

            .addCase(getMerchants.fulfilled, (state, action) => {
                state.loading = 'idle';
                state.merchants = action.payload.data
                state.error = null;
            })

            .addCase(editMerchants.fulfilled, (state, action) => {
                state.loading = 'idle';
                state.merchants = action.payload.data
                state.error = null;
            })

            .addCase(getAllPaymentMethods.fulfilled, (state, action) => {
                state.allPaymentMethods = action.payload.data
            })

            .addCase(updateMerchantPaymentMethods.fulfilled, (state, action) => {
                const updatedMerchant = action.payload.data
                const index = state.merchants.findIndex((m) => m.id === updatedMerchant.id)
                if (index !== -1) {
                    state.merchants[index] = updatedMerchant
                }
            })

            .addCase(getMerchants.rejected, (state, action) => {
                state.merchants = []
                state.loading = 'failed';
                state.error = action.payload?.code;
            })

            .addCase(editMerchants.rejected, (state, action) => {
                state.loading = 'failed';
                state.error = action.payload?.code;
            })

    }
})

export const { editArray, updateMerchantOrder, updateMerchantPaymentMethodsLocal } = merchantSlice.actions;

export default merchantSlice.reducer
